import ekozAxios from './instance/axios';

// Overview
export const getOverview = (days = 30) => ekozAxios.request({
  method: 'get',
  url: '/admin/overview/get_overview',
  params: { days },
});

// Organizations
export const getOrganizations = ({ page = 1, limit = 20, search = '' } = {}) => ekozAxios.request({
  method: 'get',
  url: '/admin/organizations/get_organizations',
  params: { page, limit, search },
});

export const getOrganization = (id) => ekozAxios.request({
  method: 'get',
  url: '/admin/organizations/get_organization',
  params: { id },
});

export const editOrganization = (data) => ekozAxios.request({
  method: 'post',
  url: '/admin/organizations/edit_organization',
  data,
});

export const deleteOrganization = (id) => ekozAxios.request({
  method: 'post',
  url: '/admin/organizations/delete_organization',
  data: { id },
});

// Users
export const getUsers = ({
  page = 1, limit = 20, search = '',
  sort = 'created_at', order = 'DESC', organizationId,
} = {}) => ekozAxios.request({
  method: 'get',
  url: '/admin/users/get_users',
  params: {
    page,
    limit,
    search,
    sort,
    order,
    organization_id: organizationId,
  },
});

export const getUser = (id) => ekozAxios.request({
  method: 'get',
  url: '/admin/users/get_user',
  params: { id },
});

export const editUser = (data) => ekozAxios.request({
  method: 'post',
  url: '/admin/users/edit_user',
  data,
});

export const searchUsers = (q) => ekozAxios.request({
  method: 'get',
  url: '/admin/users/search_users',
  params: { q },
});

export const toggleAdmin = ({ userId, isSystemAdmin }) => ekozAxios.request({
  method: 'post',
  url: '/admin/users/toggle_admin',
  data: { user_id: userId, is_system_admin: isSystemAdmin },
});

// Programs
export const getPrograms = ({ page = 1, limit = 20, search = '' } = {}) => ekozAxios.request({
  method: 'get',
  url: '/admin/programs/get_programs',
  params: { page, limit, search },
});

export const getProgram = (id) => ekozAxios.request({
  method: 'get',
  url: '/admin/programs/get_program',
  params: { id },
});

export const editProgram = (data) => ekozAxios.request({
  method: 'post',
  url: '/admin/programs/edit_program',
  data,
});

export const getCategories = () => ekozAxios.request({
  method: 'get',
  url: '/admin/programs/get_categories',
});

export const deleteProgram = (id) => ekozAxios.request({
  method: 'post',
  url: '/admin/programs/delete_program',
  data: { id },
});

// Campaigns
export const getCampaigns = ({
  page = 1, limit = 20, search = '', status, approvalStatus,
} = {}) => ekozAxios.request({
  method: 'get',
  url: '/admin/campaigns/get_campaigns',
  params: {
    page,
    limit,
    search,
    status,
    approval_status: approvalStatus,
  },
});

export const getCampaign = (id) => ekozAxios.request({
  method: 'get',
  url: '/admin/campaigns/get_campaign',
  params: { id },
});

export const editCampaign = (data) => ekozAxios.request({
  method: 'post',
  url: '/admin/campaigns/edit_campaign',
  data,
});

export const deleteCampaign = (id) => ekozAxios.request({
  method: 'post',
  url: '/admin/campaigns/delete_campaign',
  data: { id },
});

export const getCampaignReport = (id) => ekozAxios.request({
  method: 'get',
  url: '/admin/campaigns/get_campaign_report',
  params: { id },
});

// Ads
export const getAds = ({
  page = 1, limit = 20, campaignId,
} = {}) => ekozAxios.request({
  method: 'get',
  url: '/admin/ads/get_ads',
  params: { page, limit, campaign_id: campaignId },
});

export const getAd = (id) => ekozAxios.request({
  method: 'get',
  url: '/admin/ads/get_ad',
  params: { id },
});

export const editAd = (data) => ekozAxios.request({
  method: 'post',
  url: '/admin/ads/edit_ad',
  data,
});

export const deleteAd = (id) => ekozAxios.request({
  method: 'post',
  url: '/admin/ads/delete_ad',
  data: { id },
});

export const regenerateAd = (adId) => ekozAxios.request({
  method: 'post',
  url: '/admin/ads/regenerate_ad',
  data: { ad_id: adId },
});

export const getAdAudio = (generatedAdId) => ekozAxios.request({
  method: 'get',
  url: '/admin/ads/get_ad_audio',
  params: { generated_ad_id: generatedAdId },
});

// Intercom
export const getIntercomMessages = ({ page = 1, limit = 20, type } = {}) => ekozAxios.request({
  method: 'get',
  url: '/admin/intercom/get_messages',
  params: { page, limit, type },
});

export const createIntercomMessage = (data) => ekozAxios.request({
  method: 'post',
  url: '/admin/intercom/create_message',
  data,
});

export const updateIntercomMessage = (data) => ekozAxios.request({
  method: 'post',
  url: '/admin/intercom/update_message',
  data,
});

export const deleteIntercomMessage = (id) => ekozAxios.request({
  method: 'post',
  url: '/admin/intercom/delete_message',
  data: { id },
});

// Analytics
export const getAnalyticsDashboard = (days = 30) => ekozAxios.request({
  method: 'get',
  url: '/admin/analytics/get_dashboard',
  params: { days },
});

// Sessions
export const getSessions = ({
  page = 1, limit = 20, days, deviceType,
  hasRecording, excludeAdmin, email,
  funnelId, funnelStep,
} = {}) => ekozAxios.request({
  method: 'get',
  url: '/admin/sessions/get_sessions',
  params: {
    page,
    limit,
    days,
    email,
    device_type: deviceType,
    has_recording: hasRecording,
    exclude_admin: excludeAdmin,
    funnel_id: funnelId,
    funnel_step: funnelStep,
  },
});

export const getSessionDetail = (id) => ekozAxios.request({
  method: 'get',
  url: '/admin/sessions/get_session_detail',
  params: { id },
});

export const getSessionRecording = (id) => ekozAxios.request({
  method: 'get',
  url: '/admin/sessions/get_session_recording',
  params: { id },
});

export const getVisitorJourney = (visitorId) => ekozAxios.request({
  method: 'get',
  url: '/admin/sessions/get_visitor_journey',
  params: { visitor_id: visitorId },
});

// Funnels
export const getFunnels = () => ekozAxios.request({
  method: 'get',
  url: '/admin/funnels/get_funnels',
});

export const createFunnel = (data) => ekozAxios.request({
  method: 'post',
  url: '/admin/funnels/create_funnel',
  data,
});

export const updateFunnel = (data) => ekozAxios.request({
  method: 'post',
  url: '/admin/funnels/update_funnel',
  data,
});

export const deleteFunnel = (id) => ekozAxios.request({
  method: 'post',
  url: '/admin/funnels/delete_funnel',
  data: { id },
});

export const getFunnelResults = (id, days = 30) => ekozAxios.request({
  method: 'get',
  url: '/admin/funnels/get_funnel_results',
  params: { id, days },
});

export const getCustomEvents = () => ekozAxios.request({
  method: 'get',
  url: '/admin/funnels/get_custom_events',
});

// Agent
export const agentChat = (messages) => ekozAxios.request({
  method: 'post',
  url: '/admin/agent/chat',
  data: { messages },
});
